import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
	LegalAcceptanceRequest,
	LegalAcceptanceResponse
} from "@pages/profile-managment/services/agentService"
import {
	getLegalAcceptance,
	submitLegalAcceptance
} from "@pages/profile-managment/services/agentService"
import { AxiosError } from "axios"

export const useLegalAcceptanceMutations = () => {
	const queryClient = useQueryClient()

	const submitLegalAcceptanceMutation = useMutation<
		LegalAcceptanceResponse,
		AxiosError,
		LegalAcceptanceRequest
	>({
		mutationFn: async (acceptanceData: LegalAcceptanceRequest) =>
			submitLegalAcceptance(acceptanceData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["legal-acceptance"] })
		}
	})

	return {
		submitLegalAcceptanceMutation
	}
}

export const useLegalAcceptanceQuery = (enabled = true) => {
	return useQuery<LegalAcceptanceResponse, AxiosError>({
		queryKey: ["legal-acceptance"],
		queryFn: () => getLegalAcceptance(),
		enabled,
		staleTime: 5 * 60 * 1000, // 5 minutes
		refetchOnWindowFocus: false
	})
}
